import axios from "axios";
import Response from "../../models/response";
import config, { getCurrentBrand } from "../config";
import mockHeatRec from "./mockHeatRec.json";

function extractErrorMessage(data) {
  if (typeof data === "string") return data;
  if (data?.error && typeof data.error === "string") return data.error;
  if (data?.message && typeof data.message === "string") return data.message;
  if (data?.title && typeof data.title === "string") return data.title;
  return JSON.stringify(data);
}

export const recValApi = (data, getRecVal, getCoilVal) => {
  const recVal = getRecVal();
  const payload = {
    Guid: data.guid?.toString() || "",
    Id: data.projId?.toString() || "",
    RevisionNumber: data.revisionNumber?.toString() || "0",
    SummerWetBulbTemperature: data.summerWetBulbTemperature?.toString() || "0",
    SummerRelativeHumidity: data.summerOutdoorHumidity?.toString() || "0",
    SummerIndoorTemperature: data.summerIndoorTemperature?.toString() || "0",
    SummerIndoorHumidity: data.summerIndoorHumidity?.toString() || "0",
    WinterOutdoorTemperature: data.winterOutdoorTemperature?.toString() || "0",
    WinterOutdoorHumidity: data.winterOutdoorHumidity?.toString() || "0",
    WinterIndoorTemperature: data.winterIndoorTemperature?.toString() || "0",
    WinterIndoorHumidity: data.winterIndoorHumidity?.toString() || "0",
    HeaterFluidType: data.heaterType?.toString() || "water",
    HeaterFluidConcentration: data.heaterConcentration?.toString() || "0",
    FlowSupply: data.flowSupply?.toString() || "0",
    FlowReturn: data.flowReturn?.toString() || "0",
    HeatRecoveryType:
      recVal === "PPL_4" || recVal === "without"
        ? recVal
        : data.heatRecoveryPlateType?.toString() || "Rotary",
    HeatRecoverySize: data.heatRecoverySize?.toString() || "0",
    Coils: getCoilVal() || "",
    Area: data.area?.toString() || "0",
    ChangeRate: data.changeRate?.toString() || "0",
    DropReturn: data.dropReturn?.toString() || "0",
    DropSupply: data.dropSupply?.toString() || "0",
    Height: data.height?.toString() || "0",
    SummerDewPointTemperature:
      data.summerDewPointTemperature?.toString() || "0",
    SummerDryBulbTemperature: data.summerOutdoorTemperature?.toString() || "0",
    InternalWidth: data.internalWidth?.toString() || "0",
    InternalHeight: data.internalHeight?.toString() || "0",
    FanInstallationWidth: data.fanInstallationWidth?.toString() || "0",
    FanInstallationHeight: data.fanInstallationHeight?.toString() || "0",
    Elevation: data.elevation?.toString() || "0",
    FineFilterClassSupply: data.fineFilterClassSupply?.toString() || "M6",
    FineFilterClassReturn: data.fineFilterClassReturn?.toString() || "M6",
    UnitFilter: data.unitFilter?.toString() || "",
    FanType:
      data.fanType === "Standard"
        ? data.fan?.split(";")[1]?.toString() || ""
        : data.fan?.split(";")[0]?.toString() || "",
    ExternalWidth: data.externalWidth?.toString() || "0",
    ExternalHeight: data.externalHeight?.toString() || "0",
    DamperWidth: data.damperWidth?.toString() || "0",
    DamperHeight: data.damperHeight?.toString() || "0",
    FanMode: data.fanType?.toString() || "Standard",
    CoilsWidth: data.coilsWidth?.toString() || "0",
    CoilsHeight: data.coilsHeight?.toString() || "0",
    UnitTypeId: data.sizeOfUnit?.toString() || "0",
    AirflowDirection: parseInt(data.airflowDirection) || 0,
    Type: data.Type?.toString() || "",
    InternalLength: "20",
    Installation: data.installation?.toString() || "",
    recVal,
    ModelBox: data.casingQuality === "RW" ? "RW" : "XPS",
  };

  return validateRecAsync(payload);
};

export const heatValApi = (data) => {
  const payload = {
    Guid: data.guid?.toString() || "",
    Id: data.projId?.toString() || "",
    Type: data.Type,
    UnitTypeId: data.sizeOfUnit?.toString() || "0",
    Coils: data.coils?.toString() || "",
    FlowSupply: data.flowSupply?.toString() || "0",
    FlowReturn: data.flowReturn?.toString() || "0",
    HeatPumpTemperatureInWinter:
      data.heatPumpTemperatureInWinter?.toString() || "0",
    HeatPumpTemperatureInSummer:
      data.heatPumpTemperatureInSummer?.toString() || "0",
    HeatPumpHumidityInWinter: data.heatPumpHumidityInWinter?.toString() || "0",
    HeatPumpHumidityInSummer: data.heatPumpHumidityInSummer?.toString() || "0",
    HeatPumpSetPointWinter: data.heatPumpSetPointWinter?.toString() || "0",
    HeatPumpSetPointSummer: data.heatPumpSetPointSummer?.toString() || "0",
    HeatPumpMediumType: data.heatPumpMediumType?.toString() || "",
    HeatPumpMediumContentration:
      data.heatPumpMediumContentration?.toString() || "0",
    HeatPumpEvaporatingWinter:
      data.heatPumpEvaporatingWinter?.toString() || "0",
    HeatPumpCondensingWinter: data.heatPumpCondensingWinter?.toString() || "0",
    HeatPumpEvaporatingSummer:
      data.heatPumpEvaporatingSummer?.toString() || "0",
    HeatPumpCondensingSummer: data.heatPumpCondensingSummer?.toString() || "0",
     AirflowDirection: parseInt(data.airflowDirection) || 0
  };

  return validateHeatValAsync(payload);
};

export const damperValApi = (data) => {
  const toNumber = (value) => {
    if (value === "" || value === null || value === undefined) {
      return 0;
    }

    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? 0 : numericValue;
  };
    
  const buildConnectionAccessory = (width, height, isEnabled, mixingRatio) => ({
    width: toNumber(width),
    height: toNumber(height),
    isEnabled: Boolean(isEnabled),
    ...(mixingRatio !== undefined && { mixingRatio: mixingRatio !== null && mixingRatio !== "" ? toNumber(mixingRatio) : 0 }),
  });

  const unitTypeId = toNumber(data.sizeOfUnit || data.unitTypeId);
  const airFlowSupply = toNumber(data.flowSupply || data.airFlowSupply);
  const payload = {
    Guid: data.guid?.toString() || "",
    guid: data.guid?.toString() || "",
    UnitTypeId: unitTypeId.toString(),
    unitTypeId,
    AirFlowSupply: airFlowSupply.toString(),
    airFlowSupply,
    FreshAirDamper: buildConnectionAccessory(
      data.connectionFreshAirWidth,
      data.connectionFreshAirHeight,
      data.connectionFreshAirDamper,
    ),
    freshAirDamper: buildConnectionAccessory(
      data.connectionFreshAirWidth,
      data.connectionFreshAirHeight,
      data.connectionFreshAirDamper,
    ),
    SupplyAirDamper: buildConnectionAccessory(
      data.connectionSupplyAirWidth,
      data.connectionSupplyAirHeight,
      data.connectionSupplyAirDamper,
    ),
    supplyAirDamper: buildConnectionAccessory(
      data.connectionSupplyAirWidth,
      data.connectionSupplyAirHeight,
      data.connectionSupplyAirDamper,
    ),
    ReturnAirDamper: buildConnectionAccessory(
      data.connectionReturnAirWidth,
      data.connectionReturnAirHeight,
      data.connectionReturnAirEnabled && data.connectionReturnAirDamper,
      data.connectionReturnAirMixingRatio,
    ),
    returnAirDamper: buildConnectionAccessory(
      data.connectionReturnAirWidth,
      data.connectionReturnAirHeight,
      data.connectionReturnAirEnabled && data.connectionReturnAirDamper,
      data.connectionReturnAirMixingRatio,
    ),
    FreshAirFlexi: {
      width: toNumber(data.connectionFreshAirWidth),
      height: toNumber(data.connectionFreshAirHeight),
      isEnabled: Boolean(data.connectionFreshAirFlexible),
    },
    freshAirFlexi: {
      width: toNumber(data.connectionFreshAirWidth),
      height: toNumber(data.connectionFreshAirHeight),
      isEnabled: Boolean(data.connectionFreshAirFlexible),
    },
    SupplyAirFlexi: {
      width: toNumber(data.connectionSupplyAirWidth),
      height: toNumber(data.connectionSupplyAirHeight),
      isEnabled: Boolean(data.connectionSupplyAirFlexible),
    },
    supplyAirFlexi: {
      width: toNumber(data.connectionSupplyAirWidth),
      height: toNumber(data.connectionSupplyAirHeight),
      isEnabled: Boolean(data.connectionSupplyAirFlexible),
    },
    ReturnAirFlexi: {
      width: toNumber(data.connectionReturnAirWidth),
      height: toNumber(data.connectionReturnAirHeight),
      isEnabled: Boolean(data.connectionReturnAirEnabled && data.connectionReturnAirFlexible),
    },
    returnAirFlexi: {
      width: toNumber(data.connectionReturnAirWidth),
      height: toNumber(data.connectionReturnAirHeight),
      isEnabled: Boolean(data.connectionReturnAirEnabled && data.connectionReturnAirFlexible),
    },
  };

  return validateDamperAsync(payload);
};

export async function validateHeatValAsync(projItem) {
  console.log(projItem);
  let validationHeatValResult = axios
    .post(`${config.calculationUrl}/heatVal`, projItem, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "X-Brand": getCurrentBrand(),
      },
    })
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((error) => {
      let userMsg = "";
      if (error.response) {
        //Rec ili TPS dll vraca gresku koju zelimo da prikazemo korisniku
        userMsg = extractErrorMessage(error.response.data);
      } else if (error.request) {
        console.log("No response received:", error.request);
      } else {
        console.log("Error:", error.message);
      }
      throw new Error(userMsg);
    });
  return validationHeatValResult;
}

export async function validateDamperAsync(projItem) {
  let validationDamperResult = axios
    .post(`${config.calculationUrl}/damperVal`, projItem, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "X-Brand": getCurrentBrand(),
      },
    })
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((error) => {
      let userMsg = "";
      if (error.response) {
        userMsg = extractErrorMessage(error.response.data);
      } else if (error.request) {
        console.log("No response received:", error.request);
      } else {
        console.log("Error:", error.message);
      }
      throw new Error(userMsg);
    });
  return validationDamperResult;
}

export async function validateRecAsync(projItem) {
  console.log(projItem,11111);
  let validationRecResult = axios
    .post(`${config.calculationUrl}/recVal`, projItem, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "X-Brand": getCurrentBrand(),
      },
    })
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((error) => {
      let userMsg = "";
      if (error.response) {
        //Rec ili TPS dll vraca gresku koju zelimo da prikazemo korisniku
        userMsg = extractErrorMessage(error.response.data);
      } else if (error.request) {
        console.log("No response received:", error.request);
      } else {
        console.log("Error:", error.message);
      }
      throw new Error(userMsg);
    });
  return validationRecResult;
}

export async function coilsValApi(data) {
  const payload = {
    SummerRelativeHumidity: data.summerOutdoorHumidity.toString(),
    SummerIndoorTemperature: data.summerIndoorTemperature?.toString() || "0",
    SummerIndoorHumidity: data.summerIndoorHumidity?.toString() || "0",
    SummerSupplyTemperature:
      data.coolerAirInputParam === "Capacity"
        ? "-99"
        : data.coolerAirInputParamValue?.toString() || "0",
    CoolerFluidType: data.coolerType,
    CoolerFluidConcentration: data.coolerConcentration?.toString() || "0",
    CoolerFluidTemperatureIn: data.coolerTemperatureIn?.toString() || "0",
    CoolerFluidTemperatureOut:
      data.coolerWaterInputParam != "Temperature out"
        ? "-99"
        : data.coolerWaterInputParamValue?.toString() || "0",
    CoolerMediumFlowRate:
      data.coolerWaterInputParam != "Temperature out"
        ? data.coolerWaterInputParamValue?.toString() || "0"
        : "-99",
    WinterOutdoorTemperature: data.winterOutdoorTemperature?.toString() || "0",
    WinterOutdoorHumidity: data.winterOutdoorHumidity?.toString() || "0",
    WinterIndoorTemperature: data.winterIndoorTemperature?.toString() || "0",
    WinterIndoorHumidity: data.winterIndoorHumidity?.toString() || "0",
    WinterSupplyTemperature:
      data.heaterAirInputParam === "Capacity"
        ? "-99"
        : data.heaterAirInputParamValue?.toString() || "0",
    HeaterFluidType: data.heaterType,
    HeaterFluidConcentration: data.heaterConcentration?.toString() || "0",
    HeaterFluidTemperatureIn: data.heaterTemperatureIn?.toString() || "0",
    HeaterFluidTemperatureOut:
      data.heaterWaterInputParam != "Temperature out"
        ? "-99"
        : data.heaterWaterInputParamValue?.toString() || "0",

    HeaterMediumFlowRate:
      data.heaterWaterInputParam != "Temperature out"
        ? data.heaterWaterInputParamValue?.toString() || "0"
        : "-99",
    CoilsWidth: data.coilsWidth?.toString() || "0",
    CoilsHeight: data.coilsHeight?.toString() || "0",
    Coils: data.coils,
    CapacityInCooler:
      data.coolerAirInputParam === "Capacity"
        ? data.coolerAirInputParamValue?.toString() || "0"
        : "-99",
    CapacityInHeater:
      data.heaterAirInputParam === "Capacity"
        ? data.heaterAirInputParamValue?.toString() || "0"
        : "-99",
    SummerAirTemperatureIn: data.coilInputTemperatureCooler?.toString() || "0",
    SummerAirHumidityIn: data.coilInputHumidityCooler?.toString() || "0",
    WinterAirTemperatureIn: data.coilInputTemperatureHeater?.toString() || "0",
    WinterAirHumidityIn: data.coilInputHumidityHeater?.toString() || "0",
    UnitTypeId: data.sizeOfUnit?.toString() || "0",
    Guid: data.guid?.toString() || "",
    Type: data.Type?.toString() || "",
     AirflowDirection: parseInt(data.airflowDirection) || 0,
    HasDropEliminator: data.hasDropEliminator === true,
  };
  return validateCoilAsync(payload);
}

export async function validateCoilAsync(projItem) {
  let validationCoilResult = axios
    .post(`${config.calculationUrl}/coilVal`, projItem, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "X-Brand": getCurrentBrand(),
      },
    })
    .then((res) => {
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((error) => {
      let userMsg = "";
      if (error.response) {
        //Rec ili TPS dll vraca gresku koju zelimo da prikazemo korisniku
        userMsg = extractErrorMessage(error.response.data);
      } else if (error.request) {
        console.log("No response received:", error.request);
      } else {
        console.log("Error:", error.message);
      }

      throw new Error(userMsg);
    });
  return validationCoilResult;
}

export async function fanValApi(data) {
  const fanType =
    data.fanMode === "Standard"
      ? data.fan?.split(";")[1]?.toString() || ""
      : data.fan?.split(";")[0]?.toString() || "";
  const payload = {
    Guid: data.guid?.toString() || "",
    FanTypeSupply: fanType,
    FanTypeExhaust: fanType,
    FanMode: data.fanMode?.toString() || "Standard",
    DesignDryBulbTemperature: data.designDryBulbTemperature?.toString() || "0",
    DesignDewPointTemperature:
      data.designDewPointTemperature?.toString() || "0",
    DesignWetBulbTemperature: data.designWetBulbTemperature?.toString() || "0",
    DesignWinterOutdoorTemperature:
      data.designWinterOutdoorTemperature?.toString() || "0",
    FineFilterClassSupply: data.supplyAirFilterClass?.toString() || "M6",
    FineFilterClassReturn: data.returnAirFilterClass?.toString() || "M6",
    FineFilterClassFresh: data.freshAirFilterClass?.toString() || "M6",
    UnitFilter: data.unitFilter?.toString() || "",
    UnitTypeId: data.sizeOfUnit?.toString() || "0",
    FanInstallationWidth: data.fanInstallationWidth?.toString() || "0",
    FanInstallationHeight: data.fanInstallationHeight?.toString() || "0",
    Insulation: data.casingQuality?.toString() || "",
    DropSupply: data.dropSupply?.toString() || "0",
    DropReturn: data.dropReturn?.toString() || "0",
    Type: data.Type?.toString() || "",
  };
  return validateFanAsync(payload);
}

export async function validateFanAsync(projItem) {
  console.log(projItem);
  let validationFanResult = axios
    .post(
      `${config.calculationUrl}/fanVal`,
      projItem,

      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "X-Brand": getCurrentBrand(),
        },
      }
    )
    .then((res) => {
      console.log(res);
      return res.status === 200
        ? new Response(res.status, "OK!", res.data)
        : new Response(res.status, "Failed!");
    })
    .catch((error) => {
      let userMsg = "";
      if (error.response) {
        //Fan dll vraca gresku koju zelimo da prikazemo korisniku
        userMsg = extractErrorMessage(error.response.data);
      } else if (error.request) {
        console.log("No response received:", error.request);
      } else {
        console.log("Error:", error.message);
      }
      throw new Error(userMsg);
    });

  return validationFanResult;
}

export async function modularFilterApi(data) {
  const payload = {
    Guid: data.guid?.toString() || "",
    FirstStageFilterClassFresh: data.linePrimeFilterFirstStageEnabled
      ? data.linePrimeFilterFirstStageClass?.toString() || ""
      : "",
    SecondStageFilterClassFresh: data.linePrimeFilterSecondStageEnabled
      ? data.linePrimeFilterSecondStageClass?.toString() || ""
      : "",
    UnitTypeId: data.sizeOfUnit?.toString() || "0",
  };
  try {
    const res = await axios.post(
      `${config.calculationUrl}/modularFilter`,
      payload,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "X-Brand": getCurrentBrand(),
        },
      },
    );
    return res.status === 200
      ? new Response(res.status, "OK!", res.data)
      : new Response(res.status, "Failed!");
  } catch (error) {
    let userMsg = "";
    if (error.response) {
      userMsg = extractErrorMessage(error.response.data);
    } else if (error.request) {
      console.log("No response received:", error.request);
    } else {
      console.log("Error:", error.message);
    }
    throw new Error(userMsg);
  }
}

export async function ziehlAbeggFanApi(data) {
  const fanManufacturerMap = {
    "Ziehl-Abegg": "ZA",
    "EBM Papst": "EBM",
  };
  const payload = {
    Guid: data.guid?.toString() || "",
    UnitTypeId: data.sizeOfUnit?.toString() || "0",
    MotorType: data.linePrimeMotorType?.toString() || "",
    FlowSupply: data.flowSupply?.toString() || "0",
    DropSupply: data.dropSupply?.toString() || "0",
    Type: data.Type?.toString() || "",
    FanManufacturer: fanManufacturerMap[data.linePrimeFanType] || "",
  };
  try {
    const res = await axios.post(
      `${config.calculationUrl}/modularFan`,
      payload,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "X-Brand": getCurrentBrand(),
        },
      },
    );
    return res.status === 200
      ? new Response(res.status, "OK!", res.data)
      : new Response(res.status, "Failed!");
  } catch (error) {
    let userMsg = "";
    if (error.response) {
      userMsg = extractErrorMessage(error.response.data);
    } else if (error.request) {
      console.log("No response received:", error.request);
    } else {
      console.log("Error:", error.message);
    }
    throw new Error(userMsg);
  }
}

export async function ziehlAbeggFanSelectApi(data) {
  const payload = {
    Guid: data.Guid,
    FanId: data.FanId,
  };
  try {
    const res = await axios.post(
      `${config.calculationUrl}/modularFan/select`,
      payload,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "X-Brand": getCurrentBrand(),
        },
      },
    );
    return res.status === 200
      ? new Response(res.status, "OK!", res.data)
      : new Response(res.status, "Failed!");
  } catch (error) {
    let userMsg = "";
    if (error.response) {
      userMsg = extractErrorMessage(error.response.data);
    } else if (error.request) {
      console.log("No response received:", error.request);
    } else {
      console.log("Error:", error.message);
    }
    throw new Error(userMsg);
  }
}

export async function ziehlAbeggFanCalculateApi(data) {
  const fanManufacturerMap = {
    "Ziehl-Abegg": "ZA",
    "EBM Papst": "EBM",
  };
  const payload = {
    Guid: data.guid?.toString() || "",
    UnitTypeId: data.sizeOfUnit?.toString() || "0",
    MotorType: data.linePrimeMotorType?.toString() || "",
    SelectedFan: data.linePrimeSelectedFan?.type?.toString() || data.linePrimeSelectedFan?.toString() || "",
    FlowSupply: data.flowSupply?.toString() || "0",
    DropSupply: data.dropSupply?.toString() || "0",
    Type: data.Type?.toString() || "",
    Insulation: data.casingQuality?.toString() || "",
    FanManufacturer: fanManufacturerMap[data.linePrimeFanType] || "",
  };
  try {
    const res = await axios.post(
      `${config.calculationUrl}/ziehlAbeggFan/calculate`,
      payload,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "X-Brand": getCurrentBrand(),
        },
        responseType: "json",
      },
    );
    return res.status === 200
      ? new Response(res.status, "OK!", res.data)
      : new Response(res.status, "Failed!");
  } catch (error) {
    let userMsg = "";
    if (error.response) {
      userMsg = extractErrorMessage(error.response.data);
    } else if (error.request) {
      console.log("No response received:", error.request);
    } else {
      console.log("Error:", error.message);
    }
    throw new Error(userMsg);
  }
}
